'use client';
import { useEffect } from 'react';

import * as Sentry from '@sentry/nextjs';
import { useTranslations } from 'next-intl';

import {
  ErrorContainer,
  ErrorTitle,
  ErrorMessage,
  RetryButton,
} from './index.styled';

/**
 * @todo translate
 * @todo sentry
 */
export default function ClientError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const translate = useTranslations();

  useEffect(() => {
    console.error(error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <ErrorContainer>
      <ErrorTitle>{translate('client-error-fallback-ui-title')}</ErrorTitle>
      <ErrorMessage>
        {error.message || translate('client-error-fallback-ui-default-message')}
      </ErrorMessage>
      <RetryButton onClick={reset}>
        {translate('client-error-fallback-ui-button')}
      </RetryButton>
    </ErrorContainer>
  );
}
